import React, { useContext, useState } from 'react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { withRouter } from 'react-router-dom';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { useModal } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import _ from 'lodash';
import metadata from './PrintDocumentsComponent.metadata.json5';
import styles from './PrintDocumentsComponent.module.scss';
import messages from './PrintDocumentsComponent.messages.js';

function PrintDocumentsComponent(props) {
    const {
        jobNumber,
        authHeader
    } = props;

    const { showConfirm, showAlert } = useModal();
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PrintDocumentsComponent');
    const [isDocPrinted, setIsDocPrinted] = useState(false);

    const onPrintQuote = async () => {
        setIsDocPrinted(true)

        const res = await LoadSaveService.printQuoteDocument(jobNumber, 'SubmissionQuote', authHeader)
        
        setIsDocPrinted(false)

        if (res === false) {
            showAlert({
                title: messages.docFailed,
                message: messages.printQuoteFailureMsg,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        } else {
            showConfirm({
                title: messages.docSuccessed,
                message: messages.printQuoteSuccessMsg,
                status: 'info',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }
    }

    const onPrintAppQuote = async () => {
        setIsDocPrinted(true)

        const res = await LoadSaveService.printQuoteDocument(jobNumber, 'ApplicationDocument', authHeader)

        setIsDocPrinted(false)

        if (res === false) {
            showAlert({
                title: messages.docFailed,
                message: messages.printAppQuoteFailureMsg,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        } else {
            showConfirm({
                title: messages.docSuccessed,
                message: messages.printAppQuoteSuccessMsg,
                status: 'info',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }
    }

    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        printQuoteButtonId: {
            disabled: isDocPrinted
        },
        printAppButtonId: {
            disabled: isDocPrinted
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onPrintAppQuote,
            onPrintQuote
        },
        resolveClassNameMap: styles
    };



    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

PrintDocumentsComponent.propTypes = wizardProps;
export default withRouter(PrintDocumentsComponent);